import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {makeGetRequest, makePostRequest} from '../store/actions/thunk';
const useApi = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const fetchData = url => {
    setIsLoading(true);
    dispatch(makeGetRequest(url, successCallback, errorCallback));
  };

  const postData = (url, postData) => {
    setIsLoading(true);
    dispatch(makePostRequest(postData, url, successCallback, errorCallback));
  };

  const clearError = () => {
    setError(null);
  };

  const clearMultipleErrors = (...args) => {
    for (var i = 0; i < args.length; i++) {
      let caller = args[i];
      caller && caller();
    }
  };

  const successCallback = response => {
    setData(response?.data);
    setIsLoading(false);
  };

  const errorCallback = err => {
    setError(err);
    setIsLoading(false);
  };

  return {isLoading, data, error, fetchData, postData, clearError, clearMultipleErrors};
};

export default useApi;
